import { Controller } from '@hotwired/stimulus'
import Quill from 'quill'
import { DirectUpload } from '@rails/activestorage'

export default class extends Controller {
  static targets = ['input', 'editor']
  static values = { uploadUrl: String }

  connect () {
    this.quill = new Quill(this.editorTarget, {
      theme: 'snow',
      modules: {
        toolbar: {
          container: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['blockquote', 'code-block'],
            ['link', 'image'],
            ['clean']
          ],
          handlers: {
            image: this.chooseImage.bind(this)
          }
        }
      },
      placeholder: 'Write your product description…'
    })

    const initial = this.inputTarget.value
    if (initial) {
      this.quill.root.innerHTML = initial
    }

    this.quill.on('text-change', () => this.sync())
    this.sync()
  }

  disconnect () {
    this.teardown()
  }

  teardown () {
    if (!this.quill) return

    const html = this.quill.root.innerHTML
    const empty = html === '' || html === '<p><br></p>' || html === '<p></p>'
    this.inputTarget.value = empty ? '' : html

    const toolbar = this.editorTarget.previousElementSibling
    if (toolbar?.classList?.contains('ql-toolbar')) {
      toolbar.remove()
    }

    this.editorTarget.classList.remove('ql-container', 'ql-snow')
    this.editorTarget.innerHTML = this.inputTarget.value
    this.quill = null
  }

  sync () {
    const html = this.quill.root.innerHTML
    const empty = html === '' || html === '<p><br></p>' || html === '<p></p>'
    this.inputTarget.value = empty ? '' : html
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
  }

  chooseImage () {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = 'image/jpeg,image/png,image/webp,image/gif'
    input.onchange = () => {
      const file = input.files?.[0]
      if (file) this.uploadImage(file)
    }
    input.click()
  }

  uploadImage (file) {
    const upload = new DirectUpload(file, this.uploadUrlValue, this)
    upload.create((error, blob) => {
      if (error) {
        window.alert('Image upload failed. Please try again.')
        return
      }

      const url = `/rails/active_storage/blobs/redirect/${blob.signed_id}/${encodeURIComponent(blob.filename)}`
      const range = this.quill.getSelection(true) || { index: this.quill.getLength() }
      this.quill.insertEmbed(range.index, 'image', url)
      this.quill.setSelection(range.index + 1)
      this.sync()
    })
  }
}
